<template>
  <div class="page">
    <div class="app-container">
      <BaseSearch
        v-model="searchData"
        :formOptions="searchFormOption"
        @handleSearch="handleSearch"
      >
      </BaseSearch>
      <BaseTable
        ref="baseTable"
        url="/admin/correct/expire"
        :tableData.sync="tableData"
        :columns="columns"
        :searchParams="searchData"
        :paramsCepCallback="paramsCepCallback"
      >
      </BaseTable>
    </div>
  </div>
</template>

<script>
import { searchFormOption } from "./formOptions";
import { columns } from "./columns";

export default {
  name: "Search",
  comments: {},
  data() {
    return {
      tableData: [],
      orgOption: [],
      searchData: {
        dateList: [],
      },
    };
  },
  computed: {
    columns,
    searchFormOption,
  },
  created() {},
  methods: {
    // 点击搜索
    handleSearch() {
      this.$refs.baseTable.searchData(1);
    },
    // 搜索参数拦截
    paramsCepCallback(params) {
      const beginTime = this.searchData.dateList[0];
      const endTime = this.searchData.dateList[1];
      return {
        ...params,
        ...this.searchData,
        beginTime,
        endTime,
      };
    },
  },
};
</script>
